import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAddCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#add-circle_svg__a)">
      <path
        fill="#263E6A"
        d="M11.5 16.5h1v-4h4v-1h-4v-4h-1v4h-4v1h4zm.503 4.5a8.8 8.8 0 0 1-3.51-.709 9.1 9.1 0 0 1-2.859-1.922 9.1 9.1 0 0 1-1.925-2.857A8.75 8.75 0 0 1 3 12.003q0-1.866.708-3.51a9.1 9.1 0 0 1 1.924-2.859 9.1 9.1 0 0 1 2.856-1.925A8.75 8.75 0 0 1 11.997 3q1.866 0 3.51.708a9.1 9.1 0 0 1 2.859 1.924 9.1 9.1 0 0 1 1.925 2.856A8.75 8.75 0 0 1 21 11.997a8.8 8.8 0 0 1-.709 3.51 9.1 9.1 0 0 1-1.922 2.859 9.1 9.1 0 0 1-2.857 1.925 8.75 8.75 0 0 1-3.509.709M12 20q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4 6.325 6.325 4 12t2.325 5.675T12 20"
      />
    </g>
    <defs>
      <clipPath id="add-circle_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAddCircle;
